import { graphql, useStaticQuery } from 'gatsby';

export function useBlogItems() {
  const { items } = useStaticQuery(graphql`
    query BlogItems {
      items: allStoryblokEntry(
        filter: { field_component: { eq: "blogPost" } }
        sort: { fields: [first_published_at], order: DESC }
        limit: 5
      ) {
        edges {
          node {
            id
            name
            slug
            full_slug
            field_component
            tag_list
            content
            first_published_at
          }
        }
      }
    }
  `);

  return items.edges.map((edge: any) => {
    const { node } = edge;
    const content = JSON.parse(node.content);
    return {
      name: node.name,
      categories: content.categories,
      slug: node.full_slug,
      tag_list: node.tag_list,
      content: content,
      first_published_at: node.first_published_at,
      id: node.id,
      full_slug: node.full_slug,
      field_component: node.field_component
    };
  });
}
